import { gql } from '@apollo/client';

export const LOGIN = gql`
  mutation($input: LoginMutationInput!) {
    login(input: $input) {
      validCredentials
      authenticationToken {
        refreshToken
        accessToken
      }
      authenticationStep {
        token
        nextStep
      }
      twoFactorProvider {
        name
        key
      }
    }
  }
`;
